import Vue from 'vue'
import CONFIG from './../../config.js'

let actions = {
  paymentType (context) {
    context.commit('addLog', { request:'paymentType' })
    Vue.axios.get(CONFIG.getEndpoint('paymentType'),{
      withCredentials: true,
      xsrfCookieName: 'SSO_TOKEN'
    }).then((response) => {
      context.commit('removeLog', { request:'paymentType' })
      context.commit('set_payment_type', response.data)
    }).catch(()=>{
      context.commit('removeLog', { request:'paymentType' })

    })
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/paymentType/actions.js